"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var SwapRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M657.94 366.06a48 48 0 00-67.88 67.88L732.13 576H176a48 48 0 100 96h672a47.78 47.78 0 0033.96-14.06 48 48 0 000-67.88l-224.02-224z" } }] }, "name": "swap-right", "theme": "outlined" };
exports.default = SwapRightOutlined;
